// src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';
import { ContentProvider } from './components/content/ContentContext';
import { LoggedUserProvider } from './components/loggedUserContext/LoggedUserContext';
import AppRoutes from './AppRoutes';
import Footer from './components/footer/Footer';

const App = () => {
  return (
    <LoggedUserProvider>
      <Router>
        <ContentProvider>
          <div className="App">
            <AppRoutes />
          </div>
        </ContentProvider>
      </Router>
    </LoggedUserProvider>
  );
};

export default App;
